import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import GetName from 'utils/getName';
import getSi from 'utils/getSi';
import nextIssue from 'utils/nextIssue';
import updateHealthIssuesAnswers from 'utils/updateHealthIssuesAnswers';
import updateQuizInfo, { getQuizInfo } from 'utils/updateQuizInfo';
import DotDetails from '../DotDetails/DotDetails';
import DotSelector from '../DotSelector/DotSelector';

import QuizSlideHeading from '../QuizSlideHeading/QuizSlideHeading';
import QuizSlideNavigation from '../QuizSlideNavigation/QuizSlideNavigation';

const QuizDigestiveCareThree = () => {
  const navigate = useNavigate();
  const si = getSi();

  const [name, setName] = useState('');
  const contextName = useSelector((state) => state.quiz.name);
  const dispatch = useDispatch();

  useEffect(() => {
    const dogName = async () => {
      if (contextName) {
        setName(contextName);
      } else {
        const n = await GetName(si, dispatch);
        setName(n);
      }
    };
    dogName();
  }, [si]);

  useEffect(() => {
    const info = getQuizInfo();
    if (info?.digestion_q3) {
      setOption(info.digestion_q3);
    }
  }, []);

  useEffect(() => {
    if (si) {
      updateQuizInfo({ slide: 'digestive-care-3' });
      sessionStorage.setItem(
        'current_health_issue',
        JSON.stringify('digestive-care'),
      );
    } 
  }, [si]);

  const [option, setOption] = useState(1);
  const dotSelectorData = [{ name: 1 }, { name: 2 }, { name: 3 }];
  const handleClick = () => {
    if (option) {
      updateQuizInfo({ digestion_q3: option });
      updateHealthIssuesAnswers({ digestion_q3: option });
      nextIssue(navigate);
    }
  };

  const dotDetailsData = [
    {
      title: 'Not at all',
      body: 'My dog never farts - I’m a very lucky pet parent!',
    },
    {
      title: 'Somewhat',
      body: 'My dog occasionally farts and they don’t smell great',
    },
    {
      title: 'Significantly',
      body: 'My dog farts frequently, and the smell is unpleasant',
    },
  ];
  return (
    <section className="min-h-screen bg-dteal-50 pt-24 md:pt-4">
      <div className="px-9 container mx-auto flex h-screen flex-col items-center justify-center gap-9">
        <QuizSlideHeading
          before={`Does ${name}`}
          title="do smelly farts?"
          after="Smelly farts can be a sign that your dog is overproducing gas - this can be due to imbalances in the gut flora"
        />
        <div>
          <DotSelector
            data={dotSelectorData}
            option={option}
            setOption={setOption}
            details={dotDetailsData}
          />
          <DotDetails details={dotDetailsData} />
        </div>
        <QuizSlideNavigation  handleBack={()=>navigate(-1)}   handleNext={handleClick} />
      </div>
    </section>
  );
};

export default QuizDigestiveCareThree;
